import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { t } from 'helpers/i18n';
import { DatePicker } from 'elements';
class FieldDate extends Component {
    render() {
        const { date, name, withTime, required, onChange } = this.props;
        return (React.createElement(Label, null,
            t(name) + (required ? '*' : ''),
            React.createElement(DatePicker, { name: name, date: date, withTime: withTime, onChange: onChange })));
    }
}
export default FieldDate;
const Label = cxs('label')({
    padding: Theme.size.space[1],
    color: Theme.color.placeholder
});



//////////////////
// WEBPACK FOOTER
// ./src/elements/FieldDate.tsx
// module id = 376
// module chunks = 0